<template>
  <div class="input-group-container">
    <label v-if="label" :for="id" class="input-label">{{ label }}</label>
    <div class="input-group">
      <input
        type="text"
        :id="id"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :class="['input-field', { 'p-invalid': validation?.$error || error }]"
        :aria-describedby="`${id}-help`"
        @input="handleInput"
        @paste="handlePaste"
      />
      <span class="input-group-addon">
        <slot name="icon" class="input-icon"></slot>
      </span>
    </div>
    <span v-if="error" :id="`${id}-help`" class="error-message text-left mt-2">
      {{ error }}
    </span>
    <span
      v-if="validation?.$error && validation.required && validation.required.$invalid"
      :id="`${id}-help`"
      class="error-message text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", PropName) }}
    </span>
    <span
      v-else-if="validation?.$error && validation.requiredIf && validation.requiredIf.$invalid"
      :id="`${id}-help`"
      class="error-message text-left mt-2"
    >
      {{ validation.requiredIf.$message.replace("value", PropName) }}
    </span>
    <span
      v-else-if="validation?.$error && validation.email && validation.email.$invalid"
      :id="`${id}-help`"
      class="error-message text-left mt-2"
    >
      {{ validation.email.$message }}
    </span>
    <span
      v-else-if="validation?.$error && validation.numeric && validation.numeric.$invalid"
      :id="`${id}-help`"
      class="error-message text-left mt-2"
    >
      {{ validation.numeric.$message }}
    </span>
  </div>
</template>

<script>
import { sanitizeInput } from "@/utils/sanitize";

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    validation: {
      type: Object,
      required: false,
      default: () => ({})
    },
    PropName: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleInput(event) {
      const rawValue = event.target.value;
      // Remove dangerous tags like <script> but keep < character and safe HTML
      const sanitizedValue = sanitizeInput(rawValue);
      this.$emit('update:modelValue', sanitizedValue);
    },
    handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      const sanitizedText = sanitizeInput(pastedText);
      const currentValue = event.target.value;
      const start = event.target.selectionStart;
      const end = event.target.selectionEnd;
      const newValue = currentValue.substring(0, start) + sanitizedText + currentValue.substring(end);
      this.$emit('update:modelValue', newValue);
    }
  },
}
</script>

<style scoped>
.input-group-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.input-group {
  display: flex;
  align-items: stretch;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  overflow: hidden;
}

.input-field {
  flex: 1;
  padding: 10px;
  border: none;
  font-size: 16px;
  outline: none;
  color: #21211f !important;
  font-weight: 500;
  line-height: 1;
  font-family: "voyado Text";
}

.input-field::placeholder {
  color: #888;
  font-weight: normal;
  text-transform: uppercase;
  font-family: Arial, sans-serif;
}

.input-field:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: none !important;
  /* outline: 2px solid #222222 !important; */
  /* border-style: double !important; */
}

.input-group:has(.input-field:enabled:focus) {
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

/* .input-group:has(.p-invalid) {
  border-color: #dc3545;
} */

.input-group-addon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  color: #888;
}

.input-icon {
  font-size: 0.875rem;
}

.error-message {
  color: #dc3545;
  font-size: 0.75rem;
}

.text-left {
  text-align: left;
}

.mt-2 {
  margin-top: 0.5rem;
}
</style>